define(function (require, exports, module) {
    'use strict';

    var UploadReason = require('../UploadReason');

    /**
     * @constructor
     * @extends {UploadReason}
     * @param {Error} stack
     * @param {string} source
     */
    function UploadFail(stack, source) {
        if (!(this instanceof UploadFail)) {
            throw new TypeError(UploadFail.ERROR_WRONG_INSTANCE);
        }

        if (this.constructor === UploadFail) {
            throw new TypeError(UploadFail.ERROR_ABSTRACT_CLASS);
        }

        UploadReason.apply(this, arguments);
    }

    UploadFail.ERROR_WRONG_INSTANCE = 'UploadFail called on non-instance of UploadFail';
    UploadFail.ERROR_ABSTRACT_CLASS = 'UploadFail is abstract class';

    UploadFail.prototype = Object.assign(Object.create(UploadReason.prototype), {
        constructor: UploadFail,
        className: 'UploadFail',
        radarName: 'fail_{SOURCE}_abstract',
    });

    module.exports = UploadFail;
});
